import { render } from "./TableIncidence_reports.vue?vue&type=template&id=356b2fea&scoped=true"
import script from "./TableIncidence_reports.vue?vue&type=script&lang=js"
export * from "./TableIncidence_reports.vue?vue&type=script&lang=js"

import "./TableIncidence_reports.vue?vue&type=style&index=0&id=356b2fea&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-356b2fea"]])

export default __exports__